module.exports = __webpack_public_path__ + "img/img1.a971d729.svg";